export function getPendingKey(uid: string, workspaceId: string): string {
  return `tl.welcome.pending.${uid}.${workspaceId}`
}

export function getSeenKey(uid: string, workspaceId: string): string {
  return `tl.welcome.seen.${uid}.${workspaceId}`
}

export function markWelcomePending(uid?: string | null, workspaceId?: string | null): void {
  if (!uid || !workspaceId) return
  try {
    window.localStorage.setItem(getPendingKey(uid, workspaceId), '1')
  } catch {
    // Storage failures are swallowed so app flow is never blocked
  }
}

export function clearWelcomePending(uid?: string | null, workspaceId?: string | null): void {
  if (!uid || !workspaceId) return
  try {
    window.localStorage.removeItem(getPendingKey(uid, workspaceId))
  } catch {
    // Storage failures are swallowed
  }
}

export function markWelcomeSeen(uid?: string | null, workspaceId?: string | null): void {
  if (!uid || !workspaceId) return
  try {
    window.localStorage.setItem(getSeenKey(uid, workspaceId), '1')
  } catch {
    // Storage failures are swallowed
  }
}

export function isWelcomePending(uid?: string | null, workspaceId?: string | null): boolean {
  if (!uid || !workspaceId) return false
  try {
    return window.localStorage.getItem(getPendingKey(uid, workspaceId)) === '1'
  } catch {
    return false
  }
}

export function hasWelcomeBeenSeen(uid?: string | null, workspaceId?: string | null): boolean {
  if (!uid || !workspaceId) return false
  try {
    return window.localStorage.getItem(getSeenKey(uid, workspaceId)) === '1'
  } catch {
    return false
  }
}

export function shouldShowWorkspaceWelcome(uid?: string | null, workspaceId?: string | null): boolean {
  if (!uid || !workspaceId) return false
  try {
    return isWelcomePending(uid, workspaceId) && !hasWelcomeBeenSeen(uid, workspaceId)
  } catch {
    return false
  }
}
